import { Location } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  untracked,
} from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { ButtonDirective } from "primeng/button";

@Component({
  selector: "app-not-found",
  templateUrl: "./not-found.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ["./not-found.component.scss"],
  imports: [ButtonDirective, RouterLink],
})
export class NotFoundComponent {
  private location = inject(Location);

  private router = inject(Router);

  // Set by notFoundOr(); absent on an unknown url or a direct visit to /not-found. Re-read on every
  // completed navigation: a not-found → not-found navigation reuses this component. The navigation
  // in progress is untracked so leaving the page does not relabel it while the next one resolves.
  public readonly element = computed<string | null>(() => {
    const completed = this.router.lastSuccessfulNavigation();

    return (
      (untracked(this.router.currentNavigation) ?? completed)?.extras.state
        ?.element ?? null
    );
  });

  public back(): void {
    this.location.back();
  }
}
